import React from 'react';
import ReactDOM from 'react-dom/client';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import 'bootstrap-css-only/css/bootstrap-grid.min.css';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import './index.css';
import { cspNonce } from './utils/cspNonce';

// AG Grid setup moved to components/AGTable/ag-grid-setup.js
// It runs lazily when the first grid component renders.

// Emotion cache with CSP nonce — every runtime <style> tag
// injected by MUI/Emotion will carry nonce="..."
// prepend:true replicates StyledEngineProvider injectFirst behaviour
// (Emotion styles inserted first so JSS can override them).
const emotionCache = createCache({ key: 'css', nonce: cspNonce, prepend: true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <CacheProvider value={emotionCache}>
    <App />
  </CacheProvider>
);
